import { defineMessages } from 'react-intl';

export default defineMessages({
  pageTitle: {
    id: 'app.legal.mitel.pageTitle',
    defaultMessage: 'Mitel Legal Disclaimer',
  },
  header: {
    id: 'app.legal.mitel.header',
    defaultMessage: 'Legal Disclaimer',
  },
  lastUpdate: {
    id: 'app.legal.mitel.lastUpdate',
    defaultMessage: 'Last updated: {lastUpdate}',
  },
  disclaimer: {
    id: 'app.legal.mitel.disclaimer',
    defaultMessage:
      'Access to this site and the Mitel Services requires permission from Mitel. By using or accessing this site you acknowledge and agree: (i) unless otherwise agreed in writing by Mitel, your use and access to this site and the Mitel Services is governed by your Mitel Service Order which incorporates the Terms of Service at http://www.mitel.com/mnslegal ("Order").{cr}A copy of your Order is available on request; and (ii) this site contains confidential information, and may also contain content and/or enable integration with users from third-party sites which may be subject to different terms than those in the Order.{cr}You are responsible for compliance with such terms.',
  },
});
